export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/ar-arl.f6ce1f0c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};